import { isNumber } from 'lodash-es'

export type ImageRatio = '1:1' | '2:1' | '3:2' | '4:3'

export const MAX_IMAGE_WIDTH = 720
const RATIO_TOLERANCE = 0.05

const BREAKPOINTS: Record<ImageRatio, [number, number][]> = {
  '1:1': [
    [240, 240],
    [480, 480],
  ],
  '3:2': [
    [360, 240],
    [720, 480],
  ],
  '4:3': [
    [240, 180],
    [480, 360],
    [720, 540],
  ],
  '2:1': [
    [360, 180],
    [720, 360],
  ],
}

const RATIO_VALUES: [ImageRatio, number][] = [
  ['1:1', 1],
  ['3:2', 3 / 2],
  ['4:3', 4 / 3],
  ['2:1', 2],
]

export const inferImageRatio = (
  width: number,
  height: number,
): ImageRatio | undefined => {
  if (width === 0 || height === 0) return undefined

  const ratio = width / height

  // Thumbnail이 Math.ceil로 width를 계산하기 때문에 정확한 일치는 안 되고 허용 오차가 필요
  // (예: size=175, ratio='3:2' → width=263, 실제 비율 1.5028)
  return RATIO_VALUES.find(
    ([, r]) => Math.abs(ratio - r) < RATIO_TOLERANCE,
  )?.[0]
}

export const normalizeImageSize = ({
  ratio,
  size: sizeProp,
  unoptimized = false,
}: {
  ratio: ImageRatio
  size: number
  unoptimized?: boolean
}) => {
  const size = unoptimized ? sizeProp * 2 : sizeProp

  const breakpoints = BREAKPOINTS[ratio]

  const snapped = breakpoints.find(([, h]) => h >= size)

  const [width, height] = snapped ?? breakpoints[breakpoints.length - 1]

  return { width, height }
}

export const getExternalImageURL = ({
  src,
  width,
  height,
  bucket = process.env.NEXT_PUBLIC_CLOUDFRONT_BUCKET,
}: {
  src: string
  width?: number | null
  height?: number | null
  bucket?: string
}) => {
  const sizeParameter =
    isNumber(width) && isNumber(height) ? `&d=${width}x${height}` : ''

  return `https://${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${src}?b=${bucket}${sizeParameter}`
}
